import React, { useState } from 'react'
import Accordion from '@components/accordian/Accordion'
import { checkmarkColorClasses, getCheckmarkClasses, OuterPaddingTheme } from '@styles/global/helpers'
import { GridFluid } from '@styles/global/cssGrid'
import { renderSvg } from '@utils/genUtils'
import { svgs } from '@svg'
import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'
import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { ICourse } from '@et/types/Courses'
import { GATSBYIMGLOADING } from '@et/types/Enums'
import { GatsbyImage } from 'gatsby-plugin-image'
import FlashCardStatic from '@components/cards/flashCardStatic'

interface IPProps {
  shadows: {
    init: string
    hover: string
  }
  iconColor?: string
  customCheckMarkColors?: string[]
  theme: string
  cardImage: IGatsbyImageDataObject
  procreateLogo: IGatsbyImageDataObject
}

const PayWhatYouWant = (props: ICourse & IPProps) => {
  const { cardImage, onSale, salePrice, theme, price, title, classDescriptor, sellCard, tagline, shadows, iconColor = '#000', customCheckMarkColors, procreateLogo } = props
  const [tab, setTab] = useState(0)

  const flashCardProps = {
    title,
    classDescriptor,
    image: cardImage,
    sellCard,
    shadows
  }
  return (
    <div>
      <OuterPaddingTheme id={`mini-card-2`}>
        <ProcreateLogo>
          <GatsbyImage alt={'Procreate for Beginners'} image={procreateLogo.gatsbyImageData}
                       loading={GATSBYIMGLOADING.LAZY}/>
        </ProcreateLogo>
        <ProcreateHeader id={'mini-card'}>
          <h2>Welcome to Procreate 5X for Beginners</h2>
          <p>{tagline}</p>
        </ProcreateHeader>
        <GridFluid>
          <CardContainer>
            <FlashCardStatic {...flashCardProps} />
          </CardContainer>
          <Support>
            <AcStyles>
              <Accordion controlled={{ tab, setTab }}>
                {pricesArray.map((item) => (
                  <Accordion.Item key={item.title} isOpen={tab === item.id}>
                    <Accordion.Collapsed
                      id={item.id}>{item.title}<span
                      className={'acChevron'}>{renderSvg(svgs.Chevron)}</span></Accordion.Collapsed>
                    <Accordion.Expanded>
                      <PriceTabDetails url={item.url} price={item.price} content={item.content}/>
                    </Accordion.Expanded>
                  </Accordion.Item>
                ))}
              </Accordion>
            </AcStyles>

          </Support>
        </GridFluid>
      </OuterPaddingTheme>
    </div>
  )
}

export default PayWhatYouWant
const AcStyles = styled.div`
  color: #fff;
  .acItem{
    border-radius: 10px;
    border: 3px solid #4F4C4C;
    margin-bottom: 25px;
    padding: 25px 25px;
    transition: border.3s;
    
    &:hover{
      cursor: pointer;
      border-color: #fff;
      
      .acChevron{
        background: #fff;
      }
    }
    
    &.active{
      border-color: ${props => props.theme.highlight.i500};
      
      .acChevron{
        transform: rotate(0deg);
        background: #fff;
      }
      
      &:hover{
        cursor: initial;
        border-color: ${props => props.theme.highlight.i500};
      }
    }
  }
  .acHeader{
    font-weight: bold;
    font-size: 21px;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .acDetails{
    padding-top: 15px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    p{
      font-size: 18px;
    }
    a{
      padding: 12px 25px;
      margin: 15px 0 5px;
      border-radius: 50px;
      background: ${props => props.theme.highlight.i500};;
      color: #fff;
      font-weight: 700;
      transition: .3s;
      font-size: 18px;
      span{
        margin-left: 20px;
      }
      &:hover{
        color: #fff;
        cursor: pointer;
      }
    }
  }
  .acChevron{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #DDDDDD;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    transition: .1s .4s ease-in;
    transform: rotate(-90deg);

    
    svg{
      width: 100%;
      max-width: 12px;
    }
  }
`

interface IProps {
  price: number
  content: string
  url: string
}

const PriceTabDetails = ({ price, content, url }: IProps) => {
  return (
    <div className={'acDetails'}
    >
      <p>{content}</p>
      <a href={url} target={'_self'}>Enroll now! <span>${price}</span></a>
    </div>
  )
}
const pricesArray = [
  {
    id: 0,
    title: 'Free',
    content: 'Yep, it’s free! Donations below are greatly appreciated, but I want to help, no matter the budget!',
    price: 0,
    url: 'https://courses.every-tuesday.com/purchase?product_id=2693917',
  },
  {
    id: 1,
    title: 'Cup of Coffee Donation',
    content: 'Thank you! Your donation helps keep this course up + makes new ones possible! (watch for a surprise thank you gift in your inbox! ;)',
    price: 7,
    url: 'https://courses.every-tuesday.com/purchase?product_id=2695575',
  },
  {
    id: 2,
    title: '2 Cups of Coffee Donation',
    content: 'A big thank you! Now Spence (my hubs and the one who keeps this website fresh and functional) can stay caffeinated, too!  (watch for a surprise thank you gift in your inbox! ;)',
    price: 17,
    url: 'https://courses.every-tuesday.com/purchase?product_id=2695577',
  },
  {
    id: 3,
    title: 'Bag of Coffee Donation',
    content: 'A massive thank you! A virtual hug comes with this one, too ;) Thank you for helping us cover our course hosting costs and for keeping us caffeinated! (watch for a surprise thank you gift in your inbox! ;)\n',
    price: 27,
    url: 'https://courses.every-tuesday.com/purchase?product_id=2695579',
  },
]
const ProcreateHeader = styled.div`
  margin-bottom: 75px;
  h2,p{
    color: #fff;
    text-align: center;
  }
  h2{
    font-size: 34px;
    font-weight: bold;
    @media ${device.tablet}{
      font-size: 48px;
    }
    @media ${device.laptop}{
      font-size: 54px;
    }
  }
  p{
    max-width: 700px;
    margin: 0 auto;
    font-size: 21px;
  }
`
const ProcreateLogo = styled.div`
  margin: 0 auto;
  max-width: 612px;
`

const CardContainer = styled.div`
  grid-column: 2/4;
  margin: 0 0 50px;
  display: none;
  
    @media ${device.tablet}{
      margin: 0 -30px 0 0;
      padding: 0 40px 0 0;
      grid-column: 2 / 8;
      border-right: 1px solid ${props => props.theme.lineColor};
    }
    @media ${device.laptop}{
      display: flex;
      grid-column: 2 /7;
      padding: 0 30px;
    }
`

const Support = styled.div`
  grid-column: 2 / 4;
  
  grid-row: 1;
    
  h3{
    color: ${props => props.theme.headlineColor};
    margin-bottom: 15px;
    text-align: center;
  }
  ul{
    list-style: none;
  }
  li{
    position: relative;
    padding-bottom: 15px;
    color: ${props => props.theme.textColor};
  }
  
  @media ${device.tablet}{
    grid-column: 3 / 13;  
    margin: 0 30px 0;
    h3{
      text-align: left;
    }
  }
  
  @media ${device.laptop}{
      grid-column: 7 / 14;  
    }
`
